import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import Popover from "@material-ui/core/Popover";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withSnackbar } from "notistack";
import ReactQuill from "react-quill";
import $ from "jquery";
import { instance } from "../../../../../../Actions/AxiosInstance";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { textinputconverter } from "../../../../../../Component/DynamicForm/Fields/Text";
import SectionHeaderExtraSmall from "../../../../../../Component/Headers/sectionHeaderExtraSmall";
import "react-quill/dist/quill.core.css";
import "./index.scss";
import { ErrorMessages } from "../../../../../../Constants";
import { convertTOBase64 } from "../../../../../../Utils";
import VARIBALES from "./variables";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

class ComposeEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 3,
      modules: props.modules2,
      formats,
      subject: props.postData.subject || '',
      emailbody: props.emailbody || '',
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.updateChange = this.updateChange.bind(this);
    this.openPoper = this.openPoper.bind(this);
  }

  componentDidMount() {
    const x = () => {
      $("span").removeClass("ql-selected");
    };
    x();
    const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-placeholder .ql-picker-item'));
    placeholderPickerItems.forEach((item) => item.textContent = item.dataset.value);
    document.querySelector('.ql-placeholder .ql-picker-label').innerHTML = '{ }';
  }

  componentWillUnmount() {
    const { subject, emailbody } = this.state;
    const { postData } = this.props;
    postData.subject = subject;
    this.props.updateBody("emailbody", emailbody);
    this.props.updatePostData(postData);
  }

  updateChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  openPoper(e) {
    this.setState({
      open: !this.state.open,
      event: e.currentTaget,
    });
  }


  async onSubmit() {
    const { postData, templatebody, letterVariables } = this.props;
    const { emailbody, subject } = this.state;
    const bodyvariableids = [];
    const subjectvariableids = [];
    const emailvariableids = [];
    letterVariables.forEach((x) => {
      if (subject && subject.includes(`{${x.variablevalue}}`)) {
        subjectvariableids.push(x.displayvalue);
      }
      if (templatebody && templatebody.includes(`{${x.variablevalue}}`) && x.displayvalue != VARIBALES.signatory) {
        bodyvariableids.push(x.displayvalue);
      }
      if (emailbody && emailbody.includes(`{${x.variablevalue}}`) && x.displayvalue != VARIBALES.letterlink) {
        emailvariableids.push(x.displayvalue);
      }
    });
    postData.bodyvariableids = bodyvariableids.join(",") || null;
    postData.subjectvariableids = subjectvariableids.join(",") || null;
    postData.emailvariableids = emailvariableids.join(",") || null;
    postData.deletefile = [];
    postData.subject = subject;
    if (postData.subscriptionlettertemplateid) {
      if (postData.btemplatebody != templatebody) {
        const data = {
          filename: 'Letter_template.html',
          appproductid: null,
          contenttype: 'application/html',
          bufferdata: convertTOBase64(templatebody),
          employeeid: null,
        };
        const result = await instance.post("employee/uploadbufferfile", data);
        postData.bodypath = result.data.result[0].imagepath;
        postData.deletefile.push(postData.bbodypath);
      }
      if (postData.bemailbody != emailbody) {
        const data = {
          filename: 'Email_template.html',
          appproductid: null,
          contenttype: 'application/html',
          bufferdata: convertTOBase64(emailbody),
          employeeid: null,
        };
        const result = await instance.post("employee/uploadbufferfile", data);
        postData.emailbodypath = result.data.result[0].imagepath;
        postData.deletefile.push(postData.bemailbodypath);
      }
    } else {
      const data = {
        filename: 'Letter_template.html',
        appproductid: null,
        contenttype: 'application/html',
        bufferdata: convertTOBase64(templatebody),
        employeeid: null,
      };
      const result = await instance.post("employee/uploadbufferfile", data);
      postData.bodypath = result.data.result[0].imagepath;
      const data1 = {
        filename: 'Email_template.html',
        appproductid: null,
        contenttype: 'application/html',
        bufferdata: convertTOBase64(emailbody),
        employeeid: null,
      };
      console.log('data1: ', data1);
      const result1 = await instance.post("employee/uploadbufferfile", data1);
      postData.emailbodypath = result1.data.result[0].imagepath;
    }
    postData.deletefile = postData.deletefile.length > 0 ? postData.deletefile : null;
    delete postData.bbodypath;
    delete postData.btemplatebody;
    delete postData.bemailbodypath;
    delete postData.bemailbody;
    if (emailbody && !emailbody.includes(`{letter_link}`)) {
      this.props.enqueueSnackbar("Please select letter link variable inside email body", { variant: "error" });
      return;
    }
    console.log('postData: ', postData);
    if (!postData.templatename || !postData.lettercategoryid || !postData.subject || !postData.emailbodypath || !postData.bodypath) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
    } else {
      instance
        .post("letter/configlettertemplate", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
          this.props.handleClickAway();
          this.props.history.push(`${this.props.match.path}`);
          this.props.getTemplates();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    return (
      <div>
        <Grid container spacing={6}>
          <Grid item xs={12} md={10} sm={12}>
            <DynamicForm
              fields={textinputconverter({
                value: this.state.subject,
                label: "Subject",
                placeholder: "",
              })}
              onChange={(e) => this.updateChange("subject", e)}
            />
            <div className="display-table">
              <SectionHeaderExtraSmall header="📌 This subject will be visible to the employee when the letter is sent." />
            </div>
          </Grid>
          <Grid item xs={12} md={2} sm={12} style={{ padding: '48px 0px 0px 24px' }}>
            <span onClick={this.openPoper}
            className='cursor-pointer'
            style={{ color: '#057cff' }}>{ " { } "}</span>
            <Popover
              open={this.state.open}
              anchorEl={this.state.event}
              anchorOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              onClose={this.openPoper}
              className="thin-scroll"
              style={{ maxHeight: 400 }}
            >
            <Paper style={{ width: 250 }}>
              <div>
                <List className="cursor-pointer">
                  {this.props.letterVariables.filter((option) => option.displayvalue != VARIBALES.signatory && option.displayvalue != VARIBALES.letterlink).map((option) => (
                  <ListItem
                    className="padding-right-0 padding-top-2 padding-bottom-2"
                    onClick={() => this.setState({
                      subject: `${this.state.subject}{${option.variablevalue}}`,
                      open: false,
                    })}
                    style={{ height: 30 }}
                  >
                     {/* <ListItemIcon>
                      <p style={{ fontWeight: 'bold', color: '#057cff' }}>{"{ }"}</p>
                    </ListItemIcon> */}
                    <ListItemText style={{ paddingTop: 11 }}>
                      <p className="small-dark-secondary">{option.displayname}</p>
                    </ListItemText>
                  </ListItem>
                  ))}
                </List>
              </div>
            </Paper>
          </Popover>
          </Grid>
        </Grid>
        <Grid container className="margin-top-24">
          <Grid item xs={12} md={12} sm={12}>
            <p className="small-dark-secondary">Body</p>
            <div className="margin-top-8 margin-bottom-8">
              <ReactQuill
                theme="snow"
                value={this.state.emailbody || ""}
                modules={this.state.modules}
                formats={this.state.formats}
                onChange={(e) => this.updateChange("emailbody", e)}
              />
            </div>
          </Grid>
        </Grid>

        <Grid style={{ marginTop: 12 }}>
          <div style={{ marginTop: 20, float: "left" }}>
            <Button
              variant="contained"
              className="btn btn-secondary-md-blue margin-right-16"
              color="primary"
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="btn btn-primary-md-blue "
              color="primary"
              onClick={this.onSubmit}
            >
              Save
            </Button>
          </div>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(ComposeEmail);
